import { startVoiceRecording, isVoiceSupported } from '../../domain/voice.js';

export interface VoiceRecorderResult {
  text: string | null; // null = キャンセル
}

export function showVoiceRecorder(silenceTimeoutMs: number): Promise<VoiceRecorderResult> {
  return new Promise((resolve) => {
    if (!isVoiceSupported()) {
      alert('お使いのブラウザは音声入力に対応していません');
      resolve({ text: null });
      return;
    }
    const root = document.createElement('div');
    root.className = 'voice-recorder';
    root.innerHTML = `
      <div class="voice-recorder__backdrop"></div>
      <div class="voice-recorder__panel">
        <div class="voice-recorder__status">
          <span class="voice-recorder__dot" aria-hidden="true"></span>
          <span>聞いています</span>
        </div>
        <div class="voice-recorder__transcript" id="voice-transcript">…</div>
        <div class="voice-recorder__waveform" aria-hidden="true">
          ${Array.from({ length: 9 }, () => '<span></span>').join('')}
        </div>
        <div class="voice-recorder__actions">
          <button type="button" id="voice-cancel" class="voice-recorder__cancel">破棄</button>
          <button type="button" id="voice-done" class="voice-recorder__done">完了</button>
        </div>
      </div>
    `;
    document.body.appendChild(root);
    requestAnimationFrame(() => root.classList.add('is-open'));

    const transcript = root.querySelector<HTMLDivElement>('#voice-transcript')!;
    let latest = '';

    const cleanup = (result: VoiceRecorderResult) => {
      root.classList.remove('is-open');
      setTimeout(() => {
        root.remove();
        resolve(result);
      }, 200);
    };

    const recorder = startVoiceRecording({
      silenceTimeoutMs,
      onInterim: (text) => {
        latest = text;
        transcript.textContent = text || '…';
      },
      onFinal: (text) => {
        latest = text;
        transcript.textContent = text;
      },
      onError: (err) => {
        console.warn('[voice] error', err);
        if (err === 'not-allowed') alert('マイク許可が必要です');
        cleanup({ text: null });
      },
      onEnd: () => {
        cleanup({ text: latest.trim() || null });
      },
    });

    root.querySelector('#voice-cancel')!.addEventListener('click', () => {
      recorder.stop();
      cleanup({ text: null });
    });
    root.querySelector('#voice-done')!.addEventListener('click', () => {
      recorder.stop();
      // onEnd 経由で resolve される
    });
  });
}
